import React, {useEffect, useRef} from "react";
import {FormattedMessage} from "react-intl";
import {closeModal, openModal} from "../utils/dialog";

export function PaymentOutcome({outcome}: {outcome: string}) {
    const ref = useRef<HTMLDialogElement>(null);

    function handleDismiss() {
        const url = new URL(window.location.href);
        url.searchParams.delete("outcome");
        window.history.replaceState(null, "", url.href);
        closeModal(ref.current);
    }
    function outcomeContent(outcome: string) {
        switch (outcome) {
            case "SUCCESS":
                return <SuccessOutcome />;
            case "FAILURE":
                return <FailedOutcome />;
        }
    }
    useEffect(() => {
        openModal(ref.current);
    }, []);
    return (
        <dialog className="modal" ref={ref}>
            {outcomeContent(outcome)}
            <button className="secondary-button" onClick={handleDismiss}>
                <FormattedMessage id="ok" />
            </button>
        </dialog>
    );
}

function SuccessOutcome() {
    return (
        <>
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{marginBottom: "8px"}}
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM31.4142 16.4142C32.1953 15.6332 32.1953 14.3668 31.4142 13.5858C30.6332 12.8047 29.3668 12.8047 28.5858 13.5858L17.5 24.6716L12.4142 19.5858C11.6332 18.8047 10.3668 18.8047 9.58579 19.5858C8.80474 20.3668 8.80474 21.6332 9.58579 22.4142L16.0858 28.9142C16.8668 29.6953 18.1332 29.6953 18.9142 28.9142L31.4142 16.4142Z"
                    fill="var(--positive-primary)"
                />
            </svg>

            <div className="header" data-cy="modal-tip-payment-header">
                <p id="title" className="title">
                    <FormattedMessage id="tip_payment_successful" />
                </p>
            </div>
            <p className="text" data-cy="modal-tip-payment-text">
                <FormattedMessage id="tip_payment_successful_text" />
            </p>
        </>
    );
}

function FailedOutcome() {
    return (
        <>
            <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{marginBottom: "8px"}}
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM28.4142 11.5858C27.6332 10.8047 26.3668 10.8047 25.5858 11.5858L20 17.1716L14.4142 11.5858C13.6332 10.8047 12.3668 10.8047 11.5858 11.5858C10.8047 12.3668 10.8047 13.6332 11.5858 14.4142L17.1716 20L11.5858 25.5858C10.8047 26.3668 10.8047 27.6332 11.5858 28.4142C12.3668 29.1953 13.6332 29.1953 14.4142 28.4142L20 22.8284L25.5858 28.4142C26.3668 29.1953 27.6332 29.1953 28.4142 28.4142C29.1953 27.6332 29.1953 26.3668 28.4142 25.5858L22.8284 20L28.4142 14.4142C29.1953 13.6332 29.1953 12.3668 28.4142 11.5858Z"
                    fill="var(--fill-error-primary)"
                />
            </svg>

            <div className="header">
                <p id="title" className="title">
                    <FormattedMessage id="tip_payment_failed" />
                </p>
            </div>
            <p className="text">
                <FormattedMessage id="tip_payment_failed_text" />
            </p>
        </>
    );
}
